import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { colors, font, maxWidth } from "../styles/theme";
import { operator } from "../data/company";
import Footer from "../components/Footer";

// Страница «Политика обработки персональных данных».
export default function PrivacyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main style={{ background: "#fff", minHeight: "100vh" }}>
      <div style={{ maxWidth: 900, margin: "0 auto", padding: "26px 22px 60px" }}>
        <Link
          to="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 9,
            textDecoration: "none",
            fontFamily: font.display,
            fontWeight: 600,
            fontSize: 13,
            letterSpacing: ".06em",
            textTransform: "uppercase",
            color: colors.ink,
            padding: "10px 16px 10px 12px",
            background: colors.bgLight,
            border: "1px solid #e6e9ee",
            borderRadius: 10,
          }}
        >
          <ArrowLeft size={18} /> На главную
        </Link>

        <h1
          style={{
            fontFamily: font.display,
            fontWeight: 700,
            fontSize: "clamp(1.8rem,4vw,2.8rem)",
            lineHeight: 1.1,
            textTransform: "uppercase",
            margin: "26px 0 0",
            color: colors.ink,
          }}
        >
          Политика в отношении обработки персональных данных
        </h1>

        <div style={{ fontSize: 15.5, lineHeight: 1.7, color: colors.text, marginTop: 24 }}>
          <H>1. Общие положения</H>
          <P>
            Настоящая политика обработки персональных данных составлена в соответствии с требованиями Федерального
            закона от 27.07.2006 № 152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и определяет
            порядок обработки персональных данных и меры по обеспечению безопасности персональных данных, предпринимаемые{" "}
            {operator.name} (далее — Оператор).
          </P>
          <P>
            1.1. Оператор ставит своей важнейшей целью и условием осуществления своей деятельности соблюдение прав и
            свобод человека и гражданина при обработке его персональных данных, в том числе защиты прав на
            неприкосновенность частной жизни, личную и семейную тайну.
          </P>
          <P>
            1.2. Настоящая политика Оператора в отношении обработки персональных данных (далее — Политика) применяется ко
            всей информации, которую Оператор может получить о посетителях веб-сайта {operator.site}.
          </P>

          <H>2. Основные понятия, используемые в Политике</H>
          <P>
            2.1. Автоматизированная обработка персональных данных — обработка персональных данных с помощью средств
            вычислительной техники.
          </P>
          <P>
            2.2. Блокирование персональных данных — временное прекращение обработки персональных данных (за исключением
            случаев, если обработка необходима для уточнения персональных данных).
          </P>
          <P>
            2.3. Веб-сайт — совокупность графических и информационных материалов, а также программ для ЭВМ и баз данных,
            обеспечивающих их доступность в сети интернет по сетевому адресу {operator.site}.
          </P>
          <P>
            2.4. Обработка персональных данных — любое действие (операция) или совокупность действий (операций),
            совершаемых с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение
            (обновление, изменение), извлечение, использование, передачу, обезличивание, блокирование, удаление,
            уничтожение персональных данных.
          </P>
          <P>
            2.5. Оператор — юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие
            и/или осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных,
            состав персональных данных, подлежащих обработке.
          </P>
          <P>
            2.6. Персональные данные — любая информация, относящаяся прямо или косвенно к определённому или определяемому
            Пользователю веб-сайта {operator.site}.
          </P>
          <P>2.7. Пользователь — любой посетитель веб-сайта {operator.site}.</P>
          <P>
            2.8. Уничтожение персональных данных — любые действия, в результате которых персональные данные уничтожаются
            безвозвратно с невозможностью дальнейшего восстановления содержания персональных данных.
          </P>

          <H>3. Основные права и обязанности Оператора</H>
          <P>3.1. Оператор имеет право:</P>
          <Ul
            items={[
              "получать от субъекта персональных данных достоверные информацию и/или документы, содержащие персональные данные;",
              "в случае отзыва субъектом персональных данных согласия на обработку персональных данных продолжить обработку без согласия при наличии оснований, указанных в Законе о персональных данных;",
              "самостоятельно определять состав и перечень мер, необходимых для обеспечения выполнения обязанностей, предусмотренных Законом о персональных данных.",
            ]}
          />
          <P>3.2. Оператор обязан:</P>
          <Ul
            items={[
              "предоставлять субъекту персональных данных по его просьбе информацию, касающуюся обработки его персональных данных;",
              "организовывать обработку персональных данных в порядке, установленном действующим законодательством РФ;",
              "отвечать на обращения и запросы субъектов персональных данных и их законных представителей;",
              "принимать правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним;",
              "прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о персональных данных.",
            ]}
          />

          <H>4. Основные права и обязанности субъектов персональных данных</H>
          <P>4.1. Субъекты персональных данных имеют право:</P>
          <Ul
            items={[
              "получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами;",
              "требовать уточнения персональных данных, их блокирования или уничтожения в случае, если они являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки;",
              "на отзыв согласия на обработку персональных данных;",
              "обжаловать в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке неправомерные действия или бездействие Оператора.",
            ]}
          />
          <P>4.2. Субъекты персональных данных обязаны предоставлять Оператору достоверные данные о себе.</P>

          <H>5. Принципы обработки персональных данных</H>
          <P>5.1. Обработка персональных данных осуществляется на законной и справедливой основе.</P>
          <P>
            5.2. Обработка персональных данных ограничивается достижением конкретных, заранее определённых и законных
            целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.
          </P>
          <P>5.3. Обработке подлежат только персональные данные, которые отвечают целям их обработки.</P>
          <P>
            5.4. Хранение персональных данных осуществляется не дольше, чем этого требуют цели обработки, если срок не
            установлен федеральным законом или договором. Обрабатываемые персональные данные уничтожаются либо
            обезличиваются по достижении целей обработки или в случае утраты необходимости в достижении этих целей.
          </P>

          <H>6. Цели обработки персональных данных</H>
          <P>
            <b>Цель обработки:</b> обработка входящих заявок Пользователя, консультирование по услугам и связь с
            Пользователем по указанному телефону.
          </P>
          <P>
            <b>Персональные данные:</b> имя, номер телефона.
          </P>
          <P>
            <b>Правовые основания:</b> согласие субъекта персональных данных, договоры, заключаемые между Оператором и
            субъектом персональных данных.
          </P>
          <P>
            <b>Виды обработки:</b> сбор, запись, систематизация, накопление, хранение, уточнение, использование,
            уничтожение персональных данных; осуществление звонков для связи по заявке.
          </P>

          <H>7. Условия обработки персональных данных</H>
          <P>
            7.1. Обработка персональных данных осуществляется с согласия субъекта персональных данных на обработку его
            персональных данных.
          </P>
          <P>
            7.2. Обработка персональных данных необходима для исполнения договора, стороной которого либо
            выгодоприобретателем по которому является субъект персональных данных, а также для заключения договора по
            инициативе субъекта персональных данных.
          </P>
          <P>
            7.3. Обработка персональных данных необходима для осуществления прав и законных интересов Оператора или
            третьих лиц при условии, что при этом не нарушаются права и свободы субъекта персональных данных.
          </P>

          <H>8. Порядок хранения, передачи и других видов обработки персональных данных</H>
          <P>
            Безопасность персональных данных, которые обрабатываются Оператором, обеспечивается путём реализации
            правовых, организационных и технических мер, необходимых для выполнения требований действующего
            законодательства в области защиты персональных данных.
          </P>
          <P>
            8.1. Оператор обеспечивает сохранность персональных данных и принимает все возможные меры, исключающие доступ
            к персональным данным неуполномоченных лиц.
          </P>
          <P>
            8.2. Персональные данные Пользователя никогда, ни при каких условиях не будут переданы третьим лицам, за
            исключением случаев, связанных с исполнением действующего законодательства, либо в случае, если субъектом
            персональных данных дано согласие Оператору на передачу данных.
          </P>
          <P>
            8.3. Пользователь может в любой момент отозвать своё согласие на обработку персональных данных, направив
            Оператору уведомление на адрес электронной почты {operator.email} с пометкой «Отзыв согласия на обработку
            персональных данных».
          </P>
          <P>
            8.4. Срок обработки персональных данных определяется достижением целей, для которых были собраны персональные
            данные, если иной срок не предусмотрен договором или действующим законодательством.
          </P>

          <H>9. Перечень действий с персональными данными</H>
          <P>
            9.1. Оператор осуществляет сбор, запись, систематизацию, накопление, хранение, уточнение, использование,
            блокирование, удаление и уничтожение персональных данных.
          </P>
          <P>
            9.2. Оператор осуществляет автоматизированную обработку персональных данных с получением и/или передачей
            полученной информации по информационно-телекоммуникационным сетям или без таковой.
          </P>

          <H>10. Конфиденциальность персональных данных</H>
          <P>
            Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не
            распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено
            федеральным законом.
          </P>

          <H>11. Заключительные положения</H>
          <P>
            11.1. Пользователь может получить любые разъяснения по интересующим вопросам, касающимся обработки его
            персональных данных, обратившись к Оператору с помощью электронной почты {operator.email}.
          </P>
          <P>
            11.2. В данном документе будут отражены любые изменения политики обработки персональных данных Оператором.
            Политика действует бессрочно до замены её новой версией.
          </P>
          <P>11.3. Актуальная версия Политики в свободном доступе расположена по адресу {operator.policyUrl}.</P>
        </div>
      </div>
      <Footer />
    </main>
  );
}

function H({ children }) {
  return (
    <h2
      style={{
        fontFamily: font.display,
        fontWeight: 700,
        fontSize: 20,
        textTransform: "uppercase",
        color: colors.ink,
        margin: "30px 0 10px",
      }}
    >
      {children}
    </h2>
  );
}

function P({ children }) {
  return <p style={{ margin: "0 0 12px" }}>{children}</p>;
}

function Ul({ items }) {
  return (
    <ul style={{ margin: "0 0 12px", paddingLeft: 22 }}>
      {items.map((t, i) => (
        <li key={i} style={{ marginBottom: 6 }}>
          {t}
        </li>
      ))}
    </ul>
  );
}
